function navbarDropdownDirective(Subscriber, LoopBackAuthGreenback, $state, $rootScope, $timeout) {
  'ngInject';
  return {
    restrict: 'EA',
    link: function(scope, el, attrs) {
     
      Subscriber.getCurrent()
        .$promise.then(function(res) {
          $('#current-user').text(res.email);
        });

      el.on('click', function(e) {
        el.addClass('is-open');
      });

      $('.account-links-list').on('mouseleave', function(e) {
        el.removeClass('is-open');
      });

      $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParam) {
        var section = toParams.scrollTo;
        if( section ) {
          $timeout(() => {
            var offset = $(section).offset();
            $('.is-scrolled-to').removeClass('is-scrolled-to');
            $('a[href="'+section+'"]').addClass('is-scrolled-to');
            $('html, body').animate({scrollTop: offset.top}, 500);
          }, 100);
        }
      });
    }
  };
}

export default navbarDropdownDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/navbarDropdown.js